<template>
<div class="wph-checkbox">
  <label><input hidden type="checkbox" @change="onChange" :checked="value" :disabled="disabled"><span class="wph-checkbox__styled-box"></span>
    <span class="wph-checkbox__content"><slot></slot></span>
  </label>
</div>
</template>

<script>
export default {
  name: "Checkbox",
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: { type: Boolean, required: true },
    label: { type: String },
    disabled: { type: Boolean },
  },
  methods: {
    onChange() {
      this.$emit('change', !this.value)
    },
  },
}
</script>

<style scoped>

</style>